import { Component, OnInit, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators }      from '@angular/forms';
import { ErrorStateMatcher }                                        from '@angular/material/core';
import { Router, ActivatedRoute }                                   from '@angular/router';
import { first }                                                    from 'rxjs/operators';
import { NgxSpinnerService }                                        from 'ngx-spinner';

import { AlertService, DashboardService }                           from '../_services';
import { Globals }                                                  from '../_helpers';
import { SearchFilterPipe }                                         from '../_pipes';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html'
})


export class DashboardComponent implements OnInit {

    localData = {};
    loading = false;
    submitted = false;
    returnUrl: string;
    inProgress: number;
    msgObj = [];
    batchs = [];
    query:string = '';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private dashboardService: DashboardService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) {}

  	ngOnInit() {
        this.localData = JSON.parse(localStorage.getItem('currentUser'));

        /* Get Data for rendar callendar and assessor info */
        this.getBatch();
  	}


    private getBatch(){
      this.spinner.show();
        this.submitted = true;
        this.dashboardService.getBatch(this.globals.root_url, this.localData['usercode'], this.localData['id'])
          .pipe(first())
          .subscribe(
            data => {
                  if(data.code == 1000){
                      this.batchs = data.batchs;
                  }
                  else if(data.status == 'COM_TOKEN_ERROR'){
                      this.loading = false;
                      this.router.navigateByUrl('/login');
                  }
                  else{
                      this.loading = false;
                  }
                  this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }

    public nextStepFn(batchId, batch_name, exam_name, exam_date, type){
        let localbatch = {
            batchId: batchId,
            batch_name: batch_name,
            exam_name: exam_name,
            exam_date: exam_date,
            viewType: type,
        };
       
        localStorage.setItem('localBatch', JSON.stringify(localbatch));
        this.router.navigateByUrl('/exams');
    }
}
